
import { Options, mixins } from "vue-class-component";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";

interface IList {
  accountName: string;
  accountNature: string;
  accountType: string;
  netDebit: number;
}

@Options({
  title: 'Balance Sheet',
  components: {},
})

export default class BalanceSheet extends mixins(UtilityOptions) {
  private lists: IList []  = [];
  private reportService;
  private resultTitle = "";
  private storeName = "";
  private netProfit = 0;
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Reports", to: "index" },
    { label: "Balance Sheet", to: "balance-sheet-report" },
  ];

  private searchFilters = {
    date1: "",
    date2: "",
    filterType: "as_of_default",
    storeType: "single_store",
    storeID: 0,
  };

  private filterDates = [];

  private dialogTitle;
  private submitted = false;
  private filterBranch = [];

  created() {
    this.reportService = new StoreReports();
  }

  mounted() {
    this.storeList();
  }

  openDialog() {
    this.submitted = false;
    this.dialogTitle = "Filter Report";
    this.productDialog = true;
  }

  storeList() {
    this.searchFilters.storeType = 'single_store';

    this.reportService.getFilterList().then((res) => {
      this.filterBranch = res.branches.map(b => ({
        ...b,
        id: Number(b.id)
      }));

      this.filterDates = res.datesList;

      this.searchFilters.storeID = Number(res.current_branch_id);

      this.loadList();
    });
  }

  // USED TO GET SEARCHED ASSOCIATE
  loadList() {
    this.loading = true;

    this.searchFilters.storeType = (this.searchFilters.storeID && this.searchFilters.storeID !== 0)
        ? 'single_store'
        : 'all_stores';

    this.reportService.balanceSheet(this.searchFilters).then((res) => {
        const data = this.camelizeKeys(res);
        this.resultTitle = data.resultTitle;
        this.storeName = data.storeName;
        this.netProfit = Number(data.netProfit) || 0;
        this.lists = data.record;
        this.loading = false;
      });
    this.productDialog = false;
  }

  get assetAccounts() {
    return this.lists
      .filter(e => e.accountNature == 'Assets')
      .map(e => ({ accountName: e.accountName, accountType: e.accountType, balance: Number(e.netDebit) }));
  }

  get liabilityAccounts() {
    return this.lists
      .filter(e => e.accountNature == 'Liability')
      .map(e => ({ accountName: e.accountName, accountType: e.accountType, balance: -Number(e.netDebit) }));
  }

  get equityAccounts() {
    return this.lists
      .filter(e => e.accountNature == 'Equity')
      .map(e => ({ accountName: e.accountName, accountType: e.accountType, balance: -Number(e.netDebit) }));
  }

  get currentAssets() {
    return this.assetAccounts.filter(a => a.accountType == 'Current');
  }

  get nonCurrentAssets() {
    return this.assetAccounts.filter(a => a.accountType == 'Non-Current');
  }

  get currentLiabilities() {
    return this.liabilityAccounts.filter(l => l.accountType == 'Current');
  }

  get nonCurrentLiabilities() {
    return this.liabilityAccounts.filter(l => l.accountType == 'Non-Current');
  }

  get totalAssets() {
    return this.assetAccounts.reduce((sum, a) => sum + a.balance, 0);
  }

  get totalLiabilities() {
    return this.liabilityAccounts.reduce((sum, l) => sum + l.balance, 0);
  }

  get totalEquity() {
    return this.equityAccounts.reduce((sum, e) => sum + e.balance, 0) + this.netProfit;
  }

  get totalLiabilitiesAndEquity() {
    return this.totalLiabilities + this.totalEquity;
  }

  get balanceDifference() {
    return Math.abs(this.totalAssets - this.totalLiabilitiesAndEquity);
  }

  get isBalanced() {
    return this.balanceDifference < 0.01;
  }

  get currency() {
    return this.store.getters.getCurrency;
  }

  clearForFilters() {
    this.searchFilters.date1 = "";
    this.searchFilters.date2 = "";
  }

  clearSearch() {
    this.searchFilters.filterType = "None";
  }

  formatBalance(value: number): string {
    const num = Number(value);
    const formatted = this.formatAmount(Math.abs(num));
    return num < 0 ? `(${formatted})` : formatted;
  }
}
